<template>
  <v-layout row wrap>
    <PowraTitle
      :avatar="'D'"
      :title="$vuetify.t('$vuetify.powra.anyOtherHazardsPresent')"
    />
    <v-flex xs12 px-3 mt-4>
      <v-text-field
        label=""
        outline
        v-model="hazardText"
        @blur="newHazard(hazardText)"
      >
      </v-text-field>
    </v-flex>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title
          class="headline indigo darken-4 white--text"
          primary-title
        >
          {{ $vuetify.t('$vuetify.dialogs.delete.headline') }}
        </v-card-title>

        <v-card-text>
          {{ selectedHazard ? hazards[selectedHazard] : '' }}
        </v-card-text>

        <v-card-text>
          {{ $vuetify.t('$vuetify.dialogs.delete.text') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn
            color="red"
            @click="selectedHazard ? deleteHazard(selectedHazard) : ''"
          >
            {{ $vuetify.t('$vuetify.dialogs.delete.agree') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    PowraTitle
  },
  props: ['hazards'],
  data() {
    return {
      dialog: false,
      hazardText: null,
      selectedHazard: null
    }
  },
  computed: {
    ...mapState({
      // currentRiskAssessment: state => state.calls.currentRiskAssessment
    }),
    ...mapGetters({
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment'
    })
  },
  methods: {
    newHazard(text) {
      if (text) {
        this.$emit('newHazard', text)
        // this.hazardText = null
      }
    },
    // deleteHazard(index) {
    //     this.$emit('removeHazard', this.selectedHazard)
    //     this.selectedHazard = null
    //     this.dialog = false
    // },
    populateActivePowraValues() {
      this.hazardText = this.currentRiskAssessment.fields.hazards.other_hazards
        ? this.currentRiskAssessment.fields.hazards.other_hazards
        : null
    }
  },
  watch: {
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>
